import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { RootState } from 'features/app/store/store';
import { VrsChatStatus } from 'features/vrs-chat/enums';
import type { VrsChatState } from 'features/vrs-chat/interfaces';

export const initialVrsChatState: VrsChatState = {
  isShowPopup: false,
  status: VrsChatStatus.Disconnected,
  isCollapsed: false,
};

const vrsChatSlice = createSlice({
  initialState: initialVrsChatState,
  name: 'vrs-chat',
  reducers: {
    toggleVrsChatPopup: (state) => {
      state.isShowPopup = !state.isShowPopup;
    },
    openVrsChatPopup(state) {
      state.isShowPopup = true;
    },
    setVrsChatStatus(state, action: PayloadAction<VrsChatStatus>) {
      state.status = action.payload;
    },
    toggleVrsChatCollapse: (state) => {
      state.isCollapsed = !state.isCollapsed;
    },
    resetVrsChatState: () => initialVrsChatState,
  },
});

export const {
  toggleVrsChatPopup,
  resetVrsChatState,
  openVrsChatPopup,
  setVrsChatStatus,
  toggleVrsChatCollapse,
} = vrsChatSlice.actions;

export const isShowPopupSelector = ({ vrsChat }: RootState) =>
  vrsChat.isShowPopup;

export const selectVrsChatStatus = ({ vrsChat }: RootState) => vrsChat.status;

export const isVrsChatCollapsedSelector = ({ vrsChat }: RootState) =>
  vrsChat.isCollapsed;

export const vrsChatReducer = vrsChatSlice.reducer;
